"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftAPI = void 0;
const terra_js_1 = require("@terra-money/terra.js");
const BaseAPI_1 = require("./BaseAPI");
class NftAPI extends BaseAPI_1.BaseAPI {
    get executeType() {
        return ExecuteCommand;
    }
    get queryType() {
        return QueryCommand;
    }
}
exports.NftAPI = NftAPI;
class ExecuteCommand {
    setLabels({ sender, contract, data }) {
        return {
            label: `Set Labels to '${data.name}'`,
            msg: new terra_js_1.MsgExecuteContract(sender, contract, { set_labels: data })
        };
    }
    approve({ contract, data, sender }) {
        return {
            label: "Set approval",
            msg: new terra_js_1.MsgExecuteContract(sender, contract, {
                approve: data
            })
        };
    }
    revoke({ contract, data, sender }) {
        return {
            label: "Revoke an approval",
            msg: new terra_js_1.MsgExecuteContract(sender, contract, {
                revoke: data
            })
        };
    }
}
class QueryCommand extends BaseAPI_1.BaseQueryCommand {
}
